import useAuthState from '../../hooks/useAuthState';
import {Navigate, useSearchParams} from 'react-router-dom';
import {ResursLoading} from '../../components';
import {Center} from '@resurs-internal/mui';
import {
  AuthenticationErrorPage,
  AuthErrorType,
} from '../login/AuthenticationErrorPage';
import {useEffect} from 'react';

export const LoginDemoAuthenticationCallback = () => {
  const auth = useAuthState();
  const [params, setParams] = useSearchParams();

  const error = params.get('error') || auth.signInWithCode.error;
  const errorDescription = params.get('error_description');
  const setError = (error: AuthErrorType) => {
    return setParams((prev) => ({...prev, error}));
  };

  // authenticate with OAuth2 code
  useEffect(() => {
    if (params.get('error')) return;

    const code = params.get('code') ?? undefined;
    const state = params.get('state') ?? undefined;
    const codeVerifier = sessionStorage.getItem('codeVerifier') ?? undefined;
    const storedState = sessionStorage.getItem('state') ?? undefined;

    // code or state is undefined if not redirect from auth flow
    if (!code) return setError('param_code_undefined');
    if (!state) return setError('param_state_undefined');

    // param and auth state does not match if authentication was started in different browser
    if (state !== storedState) {
      return setError('auth_state_invalid');
    }
    auth.signInWithCode.mutateAsync({code, state, codeVerifier});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (Boolean(auth.state?.isLoggedIn)) {
    return <Navigate to={'/demo-main'} />;
  }

  if (error) {
    return (
      <AuthenticationErrorPage error={error} description={errorDescription} />
    );
  }

  return (
    <Center>
      <ResursLoading />
    </Center>
  );
};
